import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { GroupNameFormValues } from './types';

export const useChangeGroupNameMutation = ({ groupId }: { groupId: string }) => {
    return useRepositoryMutation('reservationGroups', 'updateName', {
        transformParams: ({ groupName }: GroupNameFormValues) => {
            return {
                groupId,
                name: groupName,
            };
        },
        onSuccess: () => {
            showSuccessAlert({ description: lt('GroupNameChangedSuccessMessage') });
        },
    });
};
